import { Moment } from 'moment';

import { Language } from '../enums';
import { Employee } from './Employee';
import { make, makeMoment } from './Model';
import { PatientMinimal } from './PatientMinimal';

export class VisitSummaryItem {
  member: PatientMinimal;

  language: Language;

  lastAppointmentDate?: Moment;

  lastAppointmentType = '';

  nextAppointmentDate?: Moment;

  nextAppointmentProvider = '';

  nextAppointmentType = '';

  npOwner?: Employee;

  attempts = '';

  constructor(obj: any) {
    Object.assign(this, obj);
    this.language = Language.byKey[obj.language];
    this.lastAppointmentDate = makeMoment(obj.lastAppointmentDate);
    this.member = make(obj.member, PatientMinimal);
    this.nextAppointmentDate = makeMoment(obj.nextAppointmentDate);
    this.npOwner = make(obj.npOwner, Employee);
  }
}

export default VisitSummaryItem;
